/**
 * UOM gate predicates for the sale price-per-area listener family, ported verbatim from:
 *
 *  - `src/app/shared/area/area.constants.ts` `isAreaUOMCheck`
 *    (AreaUOM enum: 'Square Foot' | 'Acre' | 'Hectare' | 'Square Meter')
 *  - `projects/miq/platform/src/lib/services/currency-symbol.store.ts`
 *    `isUKCurrencyCheck` / `isUKCurrencyPerSqFtCheck`
 *    (UKCurrencies enum in `projects/miq/shared-models/.../currency-symbols.constants.ts`)
 *
 * These gates decide whether a sale auto-calc fires at all (SA1–SA4). They are exact,
 * case-sensitive string membership checks — no trimming, no case folding — matching the
 * legacy `Array.includes` behaviour byte-for-byte. The gates only READ UOM values;
 * result-UOM composition (CurrencyAreaMapping / GBP-EUR `.match` branches) is a UOM
 * write and stays host-owned (T2.7).
 */
/** `AreaUOM` values accepted by the legacy `isAreaUOMCheck`. */
export const AREA_UOMS = ['Square Foot', 'Acre', 'Hectare', 'Square Meter'];
/** Whole-currency UOM names accepted by the legacy `isUKCurrencyCheck`. */
export const UK_CURRENCY_UOMS = ['Euro', 'Great Britain Pound'];
/** Currency-per-area UOM symbols accepted by the legacy `isUKCurrencyPerSqFtCheck`. */
export const UK_CURRENCY_PER_AREA_UOMS = ['£/SqFt', '€/SqFt', '£/Acre', '€/Acre', '£/Hectare', '€/Hectare', '€/Sqm', '£/Sqm'];
/** Port of `isAreaUOMCheck(uomVal)`: true iff the UOM is one of the four AreaUOM strings. */
export function isAreaUom(uom) {
  return AREA_UOMS.includes(uom);
}
/** Port of `isUKCurrencyCheck(currencyVal)`: true iff the UOM is 'Euro' or 'Great Britain Pound'. */
export function isUkCurrencyUom(uom) {
  return UK_CURRENCY_UOMS.includes(uom);
}
/** Port of `isUKCurrencyPerSqFtCheck(currencyVal)`: true iff the UOM is a £/€ per-area symbol. */
export function isUkCurrencyPerAreaUom(uom) {
  return UK_CURRENCY_PER_AREA_UOMS.includes(uom);
}
